import { CheckBox, RadioButton } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import Enums from "../../types/enums";

export const WeekdaysContainer = ({ initialValue, onChange, name, id }) => {
  const { ScheduleWeekdays, WeekdayBehavior: weekendOpt } = initialValue;

  const { t } = useTranslation(["TaskTemplateModal"], {
    useSuspense: false,
  });

  const ids = {
    checkbox: id + "_checkbox",
    after: id + "_after-weekend-radio-button",
    before: id + "_before-weekend-radio-button",
  };

  return (
    <div className="col mt-2 p-4">
      <div className="row weekends-chk">
        <CheckBox
          id={ids.checkbox}
          checked={ScheduleWeekdays}
          label={t("WeekdaysContainer.ScheduleOn")}
          change={(e) => {
            onChange({
              ScheduleWeekdays: e.checked,
              WeekdayBehavior: Enums.WeekdayBehavior,
            });
          }}
        />
      </div>
      {ScheduleWeekdays && (
        <div className="row mt-3 weekend">
          <div className="col-12 ms-2 p-2 weekend-radBtn space-y-2">
            <div className="d-flex align-self-center">
              <div className="p-2">
                <RadioButton
                  id={ids.after}
                  label={t("WeekdaysContainer.After")}
                  checked={weekendOpt === Enums.WeekdayBehavior.AfterWeekend}
                  value={"after"}
                  change={(e) => {
                    const newBehavior =
                      e.value === "before"
                        ? Enums.WeekdayBehavior.BeforeWeekend
                        : Enums.WeekdayBehavior.AfterWeekend;
                    onChange({
                      ScheduleWeekdays: ScheduleWeekdays,
                      WeekdayBehavior: newBehavior,
                    });
                  }}
                  name={name}
                />
              </div>
              <div className="p-2">
                <RadioButton
                  id={ids.before}
                  label={t("WeekdaysContainer.Before")}
                  checked={weekendOpt === Enums.WeekdayBehavior.BeforeWeekend}
                  value={"before"}
                  change={(e) => {
                    const newBehavior =
                      e.value === "before"
                        ? Enums.WeekdayBehavior.BeforeWeekend
                        : Enums.WeekdayBehavior.AfterWeekend;
                    onChange({
                      ScheduleWeekdays: ScheduleWeekdays,
                      WeekdayBehavior: newBehavior,
                    });
                  }}
                  name={name}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
